import { Component, Input, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'circle-banner',
  templateUrl: './circle-banner.component.html',
  styleUrls: ['./circle-banner.component.scss'],
})
export class CircleBannerComponent implements OnInit {

  @Input() configCircleBanner = {
    iconImg: ''
  };

  public classHead = '';

  constructor() {
    this.platformMode();
  }

  ngOnInit() { }

  private platformMode = () => {
    if (Capacitor.getPlatform() === 'ios') {
      this.classHead = 'class-ios';
    } else if (Capacitor.getPlatform() === 'android') {
      this.classHead = 'class-md';
    }
  }

}
